import React, { ComponentType, createElement, ReactNode } from 'react';
import Client from '@lt/api';
import { safetyPartnerKey, baseUrl } from '../../utils/api';
import { apiContext } from '../apiContext/apiContext';

type Props<T> = { children?: ReactNode } & T;

export const withApiContext = <T extends Record<string, any>>(component: ComponentType<T>) => {
  const apiKey = safetyPartnerKey;
  const apiBaseUrl = baseUrl || 'https://api.level.travel';

  const client = (() => {
    if (!apiKey) {
      return;
    }

    return new Client({
      key: apiKey,
      baseURL: apiBaseUrl,
    });
  })();

  if (!client) {
    console.log('Не найден ключ партнера');
  }

  const Components = (props: Props<T>) => {
    return (
      <apiContext.Provider value={{ api: client }}>
        {createElement<T>(component, props)}
      </apiContext.Provider>
    );
  };

  Components.dispayName = 'withApiContext';
  return Components;
};
